<template>
    <div>
        <div class="d-flex flex-column gap-3">
            <div v-if="isRejectedOrder">
                <div class="text-warning">
                    This order was rejected.
                </div>
            </div>
            <div v-else-if="isCancelledOrder">
                <div class="text-warning">
                    This order was cancelled by the customer.
                </div>
            </div>
            <OrderPackage v-for="shippingDetails in packages"
                          :key="shippingDetails.id"
                          :store="store"
                          :order="order"
                          :shipping-details="shippingDetails"
            />

            <div v-if="hasUnpreparedPackages && !isCancelledOrder && !isRejectedOrder" class="rounded border border-dotted p-10">
                <div class="font-weight-bold font-size-lg">
                    Reject order
                </div>
                <div>
                    In case you can not fulfill the order, you can reject the whole order here.
                </div>
                <div class="mt-3">
                    <button class="btn btn-sm btn-danger" @click="rejectWholeOrder">
                        <i class="fas fa-times-circle"/>
                        Reject this order entirely
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue2';
import {OrderState} from "@composables/orderStates"
import Alert from "@components/Alert.vue";
import OrderPackage from "@components/Orders/Package/OrderPackage.vue";

export default {
    components: {Alert, OrderPackage, Link},

    props: {
        store: Object,
        order: Object,
        packages: Array
    },

    methods: {
        rejectWholeOrder() {
            Swal.fire({
                title: `Reject order?`,
                text: 'This can not be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ea4b4b',
                confirmButtonText: 'Reject order',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$inertia.visit(this.$route('order.state', [this.store.id, this.order.url_key]), {
                        data: {
                            to_state: 'rejected',
                        },
                        method: 'PATCH',
                        only: ['order', 'users'],
                    });
                }
            });
        }
    },

    computed: {
        hasUnpreparedPackages() {
            for (let shippingDetails of this.order.shipping_details) {
                if (!shippingDetails.package_prepared) {
                    return true;
                }
            }

            return false;
        },

        isRejectedOrder() {
            return this.order.state === OrderState.Rejected;
        },

        isCancelledOrder() {
            return this.order.state === OrderState.Cancelled;
        }
    }
}
</script>
